import { DateTime } from 'luxon';

import { Timelog } from '@/tracker/types';

export type DayGroup = { day: string; worklogs: Timelog[] };

/** «11 октября», год — только если не текущий */
export const formatDay = (day: string) => {
  const date = DateTime.fromISO(day).setLocale('ru');

  return date.toFormat(date.hasSame(DateTime.now(), 'year') ? 'd MMMM' : 'd MMMM yyyy');
};

/** Логи уже отсортированы свежими вверх — группы по локальной дате начала идут в том же порядке */
export const groupByDay = (worklogs: Timelog[]): DayGroup[] =>
  worklogs.reduce<DayGroup[]>((groups, worklog) => {
    const day = DateTime.fromISO(worklog.start).toISODate()!;
    const last = groups[groups.length - 1];

    if (last?.day === day) {
      last.worklogs.push(worklog);
    } else {
      groups.push({ day, worklogs: [worklog] });
    }

    return groups;
  }, []);
